import joinClassNames from '../primitives/joinClassNames.js'

/**
 * Top-level admin section tabs (analytics, settings categories).
 * @param {'pill' | 'link'} [variant='pill'] — filled pill (ops dashboard) or text link + underline (Cook Browse/Add).
 * @param {{ tabs: { id: string, label: string }[], activeTab: string, onTabChange: (id: string) => void, className?: string, ariaLabel: string, variant?: 'pill' | 'link' }} props
 */
export default function AdminTabNav({
  tabs,
  activeTab,
  onTabChange,
  className = '',
  ariaLabel,
  variant = 'pill',
}) {
  const isLink = variant === 'link'

  if (isLink) {
    return (
      <nav
        className={joinClassNames('cook-sub-tab-bar', 'admin-link-tab-nav', className)}
        aria-label={ariaLabel}
      >
        {tabs.map(({ id, label }) => (
          <button
            key={id}
            type="button"
            role="tab"
            className={joinClassNames('cook-sub-tab', activeTab === id && 'active')}
            aria-selected={activeTab === id}
            onClick={() => onTabChange(id)}
          >
            <span className="cook-sub-tab__label">{label}</span>
          </button>
        ))}
      </nav>
    )
  }

  return (
    <nav
      className={joinClassNames('analytics-tab-nav', className)}
      aria-label={ariaLabel}
    >
      {tabs.map(({ id, label }) => (
        <button
          key={id}
          type="button"
          className={joinClassNames('analytics-tab', activeTab === id && 'active')}
          aria-current={activeTab === id ? 'page' : undefined}
          onClick={() => onTabChange(id)}
        >
          {label}
        </button>
      ))}
    </nav>
  )
}
